import { observer } from 'mobx-react';
import React from 'react';
import PublicTemplateConfigurationModal from '~/components/Templates/components/FlowTemplates/PublicTemplateConfigurationModal';
import { HBMXStatsigProvider } from '~/common/Statsig/Authenticated/MX/HBMXStatsigProvider';
import { TestIdBoundaryProvider } from '@honeybook/hbui/dist/components/common/providers/test-id-boundary.provider';

const PublicTemplateConfigurationModalContainer = () => {
    return (
        <TestIdBoundaryProvider prefix="public-template-config">
            <HBMXStatsigProvider>
                <PublicTemplateConfigurationModal />
            </HBMXStatsigProvider>
        </TestIdBoundaryProvider>
    );
};

export default observer(PublicTemplateConfigurationModalContainer);
